module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-5-f42f0d9daecb988eb7ec904ed82e4e0e.svg";